type Circle = {
  r: number
  cx: number
  cy: number
}
export type CirclePreset = {
  circle: Circle
  strokeWidth: number
  fontSize: string
}
export const presets = {
  small: {
    circle: {
      r: 17,
      cx: 19,
      cy: 19
    },
    strokeWidth: 2,
    fontSize: '.8em'
  },
  default: {
    circle: {
      r: 22,
      cx: 25,
      cy: 25
    },
    strokeWidth: 3,
    fontSize: '1em'
  },
  big: {
    circle: {
      r: 68,
      cx: 70,
      cy: 70
    },
    strokeWidth: 2,
    fontSize: '1.6em'
  }
} as const
export type PresetNames = keyof typeof presets
